export enum SUMMARY_SORT_FIELDS {
  allMeasurements = "allMeasurements",
  daysWithReading = "daysWithReading",
  timer = "timer",
  "-allMeasurements" = "-allMeasurements",
  "-daysWithReading" = "-daysWithReading",
  "-timer" = "-timer",
}
export default SUMMARY_SORT_FIELDS;
